/**
 * @file Purchase Album Photos related actions.
 */

import getLogger from '../util/logger';

const log = getLogger('PurchaseAlbumPhotosAction');

export const SELECT_PHOTO = 'purchase-album-photos/SELECT_PHOTO';
export const DESELECT_PHOTO = 'purchase-album-photos/DESELECT_PHOTO';
export const CHECKOUT_REQUEST = 'purchase-album-photos/CHECKOUT_REQUEST';
export const CHECKOUT_SUCCESS = 'purchase-album-photos/CHECKOUT_SUCCESS';
export const CHECKOUT_FAILURE = 'purchase-album-photos/CHECKOUT_FAILURE';

export const selectPhoto = photo => {
  return { type: SELECT_PHOTO, photo };
};

const deselectPhoto = photo => {
  return { type: DESELECT_PHOTO, photo };
};

export const onSelectPhoto = photo => dispatch => {
  log.info('onSelectPhoto() :: Selected photo:', photo);

  dispatch(selectPhoto(photo));
};

export const onDeselectPhoto = photo => dispatch => {
  log.info('onDeselectPhoto() :: Deselected photo:', photo);

  dispatch(deselectPhoto(photo));
};

const checkoutRequest = () => {
  return { type: CHECKOUT_REQUEST };
};

const checkoutSuccess = purchasedUrl => {
  return { type: CHECKOUT_SUCCESS, purchasedUrl };
};

const checkoutFailure = error => {
  return { type: CHECKOUT_FAILURE, error };
};

export const checkout = async (
  albumMembershipId,
  email,
  stripeToken,
  photos,
  dispatch,
  checkoutPpdPerPhoto,
  stripePaymentMethodId,
  stripeConnectAccountId,
) => {
  log.info('checkout() :: Purchasing photos...', photos);

  dispatch(checkoutRequest());

  try {
    const res = await checkoutPpdPerPhoto(
      albumMembershipId,
      email,
      stripeToken,
      photos.map(photo => photo.id),
      stripePaymentMethodId,
      stripeConnectAccountId,
    );
    const checkoutData = res.data.checkoutPpdPerPhoto;

    if (checkoutData.is_paid) {
      dispatch(checkoutSuccess(checkoutData.purchased_url));

      log.info('checkout() :: Checkout success');
    } else {
      const errorMessage = checkoutData.errors.join('. ');

      dispatch(
        checkoutFailure({
          message: errorMessage,
        }),
      );

      log.error('checkout() :: Error:', errorMessage);
    }
  } catch (error) {
    log.error('checkout() :: Error:', error);

    dispatch(checkoutFailure(error));
  }
};
